/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Realitymix_InactiveInputs */

const cs_realitymix_inactive = /** @type {(inputs: Realitymix_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neaktivní`)
};

const en_realitymix_inactive = /** @type {(inputs: Realitymix_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactive`)
};

/**
* | output |
* | --- |
* | "Inactive" |
*
* @param {Realitymix_InactiveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const realitymix_inactive = /** @type {((inputs?: Realitymix_InactiveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Realitymix_InactiveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_realitymix_inactive(inputs)
	return cs_realitymix_inactive(inputs)
});